
import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getMedal } from "data/Querys";
import MirsTable from 'components/general/table/Table.js';
import Label from 'components/general/Label';
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import { Button, Stack } from 'react-bootstrap';
import SelectorDiscipline from 'components/common/selectors/selector-discipline/selectorDiscipline';
import SelectorNoc from 'components/common/selectors/selector-noc';
import { ALL_URL, SELECTOR_DISPLAY_TYPE, isParalympic } from "helpers/utils";
import SelectorGender from 'components/common/selectors/selector-gender';
import Medal from 'components/presentation/Medal';
import Noc from 'components/presentation/Noc';
import useViewport from 'components/general/useViewPort';

const getConfiguration = ({ breakPoint, isAlphabeticalOrder = true }) => {
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        columns: [],
        sortBy: [],
        disableSort: false
    };
    // configuration.sortBy = [{ id: 'Rank', desc: false }];
    configuration.sortBy = [];
    configuration.columns = isMobile ? TableColumnsSM(isAlphabeticalOrder) : TableColumns(isAlphabeticalOrder);
    return configuration;
};

export default function MedalTable() {
    const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters();
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    const [nocs, setNocs] = useState([]);
    const [disciplines, setDisciplines] = useState([]);
    const [genders, setGenders] = useState([]);
    const [medalItems, setMedalItems] = useState([]);
    const [selectedNoc, setSelectedNoc] = useState('');
    const [selectedGender, setSelectedGender] = useState('');
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, "medal")
    //copy parameters URL to change 
    //let paramsURL = { ...params }

    //Get Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['medalTable', mirs_competition, mirs_language],
            queryFn: getMedal,
            refetchInterval: 5000,
        });

    useEffect(() => {
        const dataUpdate = JSON.parse(JSON.stringify(data?.medalNOC || [])); //Deep copy all elements primitive values (ineficiente??)
        //Si no hacemos lo anterior se repintara cada vez que se carguen los datos aunque estos no hayan cambiado  ya que los datos se pasan por refencia y los detactara como que hay cambios con lo anterior
        //Copy organisation data in every row data for  table

        dataUpdate?.forEach((item, index) => {
            item.participant = { organisation: { ...item.organisation } }
        });

        //Filters
        const tempDisciplines = new Set();
        const tempNocs = new Set();
        const tempGenders = new Set();
        const tempMedalItems = [];
        dataUpdate?.forEach(medalItem => {
            let tempDiscipline = medalItem?.sport;
            let tempNoc = medalItem?.organisation?.code;
            let tempGender = medalItem?.gender;

            let tempMedalItem = medalItem;

            if (selectedNoc && selectedNoc !== ALL_URL.ALL_NOC) {
                if (medalItem?.participant?.organisation?.code !== selectedNoc) {
                    tempMedalItem = "";
                    tempDiscipline = "";
                    tempGender = "";
                }
            }

            if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
                if (medalItem?.sport !== mirs_discipline) {
                    tempMedalItem = "";
                    tempNoc = "";
                    tempGender = "";
                }
            } else {
                if (medalItem?.sport !== "GLO") {
                    tempMedalItem = "";
                    tempNoc = "";
                    tempGender = "";
                }
            }

            if (selectedGender && selectedGender !== ALL_URL.ALL_GENDER) {
                if (medalItem?.gender !== selectedGender) {
                    tempMedalItem = "";
                    tempNoc = "";
                    tempDiscipline = "";

                }
            } else {
                if (medalItem?.gender !== ALL_URL.ALL_GENDER) {
                    tempMedalItem = "";
                    tempNoc = "";
                    tempDiscipline = "";
                }
            }

            if (tempMedalItem) {
                tempMedalItems.push(tempMedalItem);
            }

            if (tempDiscipline) {
                tempDisciplines.add(tempDiscipline);
            }

            if (tempNoc) {
                tempNocs.add(tempNoc);
            }

            if (tempGender && tempGender !== ALL_URL.ALL_GENDER) {
                tempGenders.add(tempGender);
            }

        });

        setMedalItems(tempMedalItems);
        setDisciplines([...tempDisciplines]);
        setNocs([...tempNocs]);
        setGenders([...tempGenders]);
    }, [data?.medalNOC, mirs_discipline, selectedGender, selectedNoc]);

    const onSelectNoc = (nocCode) => {
        setSelectedNoc(nocCode);
    };

    const onSelectGender = (genderCode) => {
        setSelectedGender(genderCode);
    };

    if (isError) { return <NotAvailable label="LabelNoDataAvailable" />; }
    if (isLoading) { return <Loader />; }
    if (!data?.medalNOC) { return <NotAvailable label="LabelNoDataAvailable" /> }

    return (
        <>
            {/**
            <Form.Select aria-label="Default select example">
                <option>Open this select menu</option>
                <option value="1">Germany</option>
                <option value="2">France</option>
                <option value="3">Spain</option>
            </Form.Select>



            <Dropdown>
                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                    Custom toggle
                </Dropdown.Toggle>

                <Dropdown.Menu as={CustomMenu}>
                    <Dropdown.Item eventKey="1">Red</Dropdown.Item>
                    <Dropdown.Item eventKey="2">Blue</Dropdown.Item>
                    <Dropdown.Item eventKey="3" active>
                        Orange
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="1">Red-Orange</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>,
 */}

            <DrawComponent dataFilter={medalItems} disciplinesList={disciplines} nocsList={nocs} gendersList={genders} onSelectNoc={onSelectNoc} selectedNoc={selectedNoc} onSelectGender={onSelectGender} selectedGender={selectedGender} />
        </>
    )
};


function DrawComponent({ dataFilter, disciplinesList, nocsList, gendersList, onSelectNoc, selectedNoc, onSelectGender, selectedGender }) {
    const { breakPoint } = useViewport();
    const [isAlphabeticalOrder, setIsAlphabeticalOrder] = useState(true)
    const { mirs_competition } = useUrlFriendlyToParameters();
    const config = useMemo(() => getConfiguration({ breakPoint, isAlphabeticalOrder }), [breakPoint, isAlphabeticalOrder]);
    const [initialSort, setInitialSort] = useState([{ id: 'Rank', desc: false }]);

    useEffect(() => {
        isAlphabeticalOrder ? setInitialSort([{ id: 'Rank', desc: false }]) : setInitialSort([{ id: 'NOC', desc: false }]);
    }, [isAlphabeticalOrder]);

    return (
        <div className='mirs-page-container'>
            <Stack direction="horizontal" className="selectors-container">
                <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="medal" useDisciplinesList={true} disciplinesList={disciplinesList} />
                <SelectorNoc page="medal" useNocList={true} nocsList={nocsList} onSelectNoc={onSelectNoc} selectedNoc={selectedNoc} />
                <SelectorGender page="medal" gendersList={gendersList} useGendersList={true} onSelectGender={onSelectGender} selectedGender={selectedGender} />
                <div className="orderMedalSelector">
                    <Button className={isAlphabeticalOrder ? 'orderMedalSelectorButton' : ''} variant="link" onClick={() => setIsAlphabeticalOrder(true)}>{<Label data={"MedalOrder"} />}</Button>
                    <Button className={!isAlphabeticalOrder ? 'orderMedalSelectorButton' : ''} variant="link" onClick={() => setIsAlphabeticalOrder(false)}>{<Label data={"ProtocolOrder"} />}</Button>
                </div>
            </Stack>
            < MirsTable
                id={'mirs-table-medal'}
                columns={config.columns}
                data={dataFilter}
                showLoading={false}
                initialSortBy={initialSort}
            />
            {!!dataFilter?.length && <div>
                <br />
                <Label data={isParalympic(mirs_competition) ? 'MedalTallyDisclaimerNPC' : 'MedalTallyDisclaimerNOC'} />
            </div>}
        </div>
    )
}

export function TableColumns(isAlphabeticalOrder) {
    return (
        [
            ColumnRank({}),
            ColumnNoc({ label: "HeaderTeamNOC", isAccessorAhphabetic: isAlphabeticalOrder, longDesc: true }),
            // ColumnOrganisation({}),
            ColumnGold(),
            ColumnSilver(),
            ColumnBronze(),
            ColumnTotal(),
            ColumnRankTotal(),

        ]
    )
}

export function TableColumnsSM(isAlphabeticalOrder) {
    return (
        [
            ColumnRank({}),
            ColumnNoc({
                label: "HeaderTeamNOC", isAccessorAhphabetic: isAlphabeticalOrder,
                longDesc: false,
                className: 'text-start',
                headerClassName: 'text-start w-5 align-middle',
            }),
            ColumnGold(),
            ColumnSilver(),
            ColumnBronze(),
            ColumnTotal(),
            ColumnRankTotal(),

        ]
    )
}

function ColumnNoc({
    className = 'text-start d-none d-md-table-cell ',
    headerClassName = 'text-start d-none d-md-table-cell w-5 align-middle',
    label = 'HeaderNOC',
    isAccessorAhphabetic = true,
    disableSort = false,
    longDesc = false,
    remove = false
}) {
    return (
        {
            Header: <Label data={label} legendFixed={true} />,
            id: 'NOC',
            accessor: (props) => {
                return isAccessorAhphabetic ? props?.organisation?.longDescription?.toLowerCase() : props?.organisation?.protocolOrder;
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            remove: remove,
            Cell: (props) => {
                let data = props.cell.row.original?.organisation
                return (<Noc {...data} showLongDesc={longDesc} />)
            }
        }
    )
}

function ColumnRank() {
    return (
        {
            Header: <Label data={"HeaderOrder"} />,
            accessor: 'sortRank',
            className: "text-start",
            headerClassName: "text-start w-5 text-nowrap",
            disableSortBy: false,
            id: 'Rank',
            Cell: (props) => {
                return props.cell.row.original.rank
            }
        }
    )
}

function ColumnGold() {
    return (
        {
            Header: <Medal code={'1'} />,
            accessor: 'gold',
            className: "text-end",
            headerClassName: "medallist-medal text-end w-5 text-nowrap",
            disableSortBy: false,
            multiSort: [{ id: 'Gold' }, { id: 'Rank', desc: false }],
            id: 'Gold',

        }
    )
}

function ColumnSilver() {
    return (
        {
            Header: <Medal code={'2'} />,
            accessor: 'silver',
            className: "text-end",
            headerClassName: "medallist-medal text-end w-5 text-nowrap",
            disableSortBy: false,
            multiSort: [{ id: 'Silver' }, { id: 'Rank', desc: false }],
            id: 'Silver',

        }
    )
}

function ColumnBronze() {
    return (
        {
            Header: <Medal code={'3'} />,
            accessor: 'bronze',
            className: "text-end",
            headerClassName: "medallist-medal text-end w-5 text-nowrap",
            disableSortBy: false,
            multiSort: [{ id: 'Bronze' }, { id: 'Rank', desc: false }],
            id: 'Bronze',

        }
    )
}

function ColumnTotal() {
    return (
        {
            Header: <Label data={"HeaderTotal"} />,
            accessor: 'total',
            className: "text-end",
            headerClassName: "text-end w-5 text-nowrap",
            disableSortBy: false,
            multiSort: [{ id: 'Total' }, { id: 'Rank', desc: false }],
            id: 'Total',

        }
    )
}

function ColumnRankTotal() {
    return (
        {
            Header: <Label data={"HeaderRankByTotal"} />,
            accessor: 'sortRankTotal',
            className: "text-end",
            headerClassName: "text-end w-5",
            disableSortBy: false,
            id: 'RankByTotal',
            multiSort: [{ id: 'RankByTotal' }, { id: 'Rank', desc: false }],
            Cell: (props) => {
                return props.cell.row.original.rankTotal
            }
        }
    )
}

















